import flatpickr from 'flatpickr'

export default (el) => {
  flatpickr(el, {
    dateFormat: 'Y-m-d',
    disableMobile: 'true',
    minDate: el.getAttribute('min'),
    maxDate: el.getAttribute('max')
  })
}
